import { useEffect, useState } from 'react';

/**
 * Owns the ⌘K / Ctrl+K command-palette open state + the global hotkey that toggles
 * it (Phase 10). Extracted from AppShell so the shell stays under the file-size
 * ceiling and the palette's activation lives with the palette. Returns the open
 * state + a setter to feed `CommandPalette`.
 */
export function useCommandPalette(): { open: boolean; setOpen: (open: boolean) => void } {
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onKeyDown = (event: KeyboardEvent): void => {
      if ((event.metaKey || event.ctrlKey) && (event.key === 'k' || event.key === 'K')) {
        event.preventDefault();
        setOpen((prev) => !prev);
      }
    };
    window.addEventListener('keydown', onKeyDown);
    return () => {
      window.removeEventListener('keydown', onKeyDown);
    };
  }, []);

  return { open, setOpen };
}
